import { ReactNode } from "react";
import { AGENT_NAME } from "../../constants/fetch/chatRoom";
import AgentFetchLogo from '../../images/fetch-logo.png';


interface ResponseContainerI {
    children: ReactNode;
}

const ResponseContainer = (props: ResponseContainerI) => {

    const { children } = props;

    return (
        <div className='flex flex-row items-start pb-5 w-full'>
            <div className='min-w-8 min-h-8 !p-0'>
                <img src={AgentFetchLogo} alt='Agent Fetch Logo' className='w-8 h-8 object-contain rounded-full' />
            </div>
            <div className="flex flex-col ml-3 gap-2 !w-full">
                <div className="font-semibold">{AGENT_NAME}</div>
                <div className='flex flex-col !w-full'>
                    {children}
                </div>
            </div>
        </div>
    );

}

export default ResponseContainer;